import { useNavigate } from 'react-router-dom';
import { FiTrash2 } from 'react-icons/fi';
import { IoChevronForward } from 'react-icons/io5';
import PlatformBadge, { getPlatform } from '../PlatformBadge/PlatformBadge';
import RefreshButton from '../RefreshButton/RefreshButton';
import './PlatformLoginCard.css';

const formatRelative = (iso) => {
  if (!iso) return 'never';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

const PlatformLoginCard = ({ login, uploadCount, onUnlink, onRefreshed }) => {
  const navigate = useNavigate();
  const platform = getPlatform(login.platform);

  return (
    <div className="login-card" onClick={() => navigate(`/logins/${login.id}`)}>
      <div className="login-card-main">
        <PlatformBadge platform={login.platform} size="lg" />
        <div className="login-card-text">
          <div className="login-card-title-row">
            <h3 className="login-card-title">{platform?.label || login.platform}</h3>
            <span className="login-card-username">{login.platformUsername}</span>
          </div>
          <div className="login-card-meta">
            <span>
              {uploadCount} {uploadCount === 1 ? 'upload' : 'uploads'}
            </span>
            <span className="login-card-dot">•</span>
            <span>Last refreshed {formatRelative(login.lastRefreshedAt)}</span>
          </div>
        </div>
      </div>
      <div className="login-card-actions" onClick={(e) => e.stopPropagation()}>
        <RefreshButton
          level="login"
          id={login.id}
          onRefreshed={onRefreshed}
          variant="ghost"
          label="Refresh"
        />
        <button
          className="login-card-delete"
          onClick={() => onUnlink(login)}
          title="Unlink"
        >
          <FiTrash2 />
        </button>
        <div className="login-card-chevron">
          <IoChevronForward />
        </div>
      </div>
    </div>
  );
};

export default PlatformLoginCard;
